import Vue from 'vue'
import Router from 'vue-router'

import index from '@/views/index/index'
import mIndex from '@/views/index/m_index'

import products from '@/views/products/index'
import productsDetail from '@/views/products/detail'
import mProductsDetail from '@/views/products/M_detail'
import cases from '@/views/cases/index'
import casesDetail from '@/views/cases/detail'
import mCases from '@/views/cases/m_index'
import mCasesDetail from '@/views/cases/m_detail'

import about from '@/views/about/index'
import contact from '@/views/contact/index'
import mContact from '@/views/contact/m_index'
import mProducts from '@/views/products/m_index'
import mAbout from '@/views/about/m_index'

import scheme from '@/views/scheme/index'
import mScheme from '@/views/scheme/m_index'


import honor from '@/views/honor/index'
import mHonor from '@/views/honor/m_index'
import news from '@/views/news/index'
import milestone from '@/views/milestone/index'
import mMilestone from '@/views/milestone/m_index'
import mNews from '@/views/news/m_index'


import productAssembly from '@/views/products/assembly'

import mproductAssembly from '@/views/products/m_assembly'

// import newsDetail from '@/views/news/detail'



Vue.use(Router)

const pc = [
  {
    path: '/',
    name: 'index',
    component: index
  },
  {
    path: '/index',
    name: 'index',
    component: index
  },
  {
    path: '/products',
    name: 'products',
    component: products,
    meta:{
      keepAlive:true
    }
  },
  {
    path: '/productAssembly',
    name: 'productAssembly',
    component: productAssembly
  },
  {
    path: '/cases',
    name: 'cases',
    component: cases
  },
  {
    path: '/casesDetail',
    name: 'casesDetail',
    component: casesDetail
  },
  {
    path: '/about',
    name: 'about',
    component: about
  },
  {
    path: '/contact',
    name: 'contact',
    component: contact
  },
  {
    path: '/scheme',
    name: 'scheme',
    component: scheme
  },
  {
    path: '/productsDetail',
    name: 'productsDetail',
    component: productsDetail
  },
  {
    path: '/news',
    name: 'news',
    component: news
  },
  // {
  //   path: '/newsDetail',
  //   name: 'newsDetail',
  //   component: newsDetail
  // },
  {
    path: '/honor',
    name: 'honor',
    component: honor
  },
  
  {
    path: '/milestone',
    name: 'milestone',
    component: milestone
  },
  {
    path: '/contact ',
    name: 'contact ',
    component: contact 
  }
];

const mobile = [
  {
    path: '/',
    name: 'index',
    component: mIndex
  },
  {
    path: '/index',
    name: 'index',
    component: mIndex
  },
  {
    path: '/products',
    name: 'products',
    component: mProducts,
    meta:{
      keepAlive:true
    }
  },
  {
    path: '/productAssembly',
    name: 'productAssembly',
    component: mproductAssembly
  },
  {
    path: '/about',
    name: 'about',
    component: mAbout
  },
  {
    path: '/honor',
    name: 'honor',
    component: mHonor
  },
  {
    path: '/contact ',
    name: 'contact ',
    component: mContact 
  },
  {
    path: '/news',
    name: 'news',
    component: mNews
  },
  {
    path: '/scheme',
    name: 'scheme',
    component: mScheme
  },
  {
    path: '/cases',
    name: 'cases',
    component: mCases
  },
  {
    path: '/casesDetail',
    name: 'casesDetail',
    component: mCasesDetail
  },
  {
    path: '/productsDetail',
    name: 'productsDetail',
    component: mProductsDetail
  },
  {
    path: '/milestone',
    name: 'milestone',
    component: mMilestone
  }
  
];

var routes = [];

if(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
    routes = mobile
  //  routes=pc
}else {
  routes = pc
}

export default new Router({
  routes: routes,
  mode: 'hash',
   scrollBehavior(){
        return{
          selector:'#app',
        }
      }
})



// WEBPACK FOOTER //
// ./src/router/index.js